import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

// icon
import { CiCalendar } from "react-icons/ci";
import { FiClock } from "react-icons/fi";

// images
import Newsimage1 from "./Images/newsbox image-1.svg";
import Newsimage2 from "./Images/newsbox image-2.svg";
import Newsimage3 from "./Images/newsbox image-3.svg";
import Whyjoinbg from "./Images/whyjoin-background.svg";
import ManImage from "./Images/whyjoinMan.svg";
import welcomeimage from "./Images/welocomeimage.svg";
import connectNowbg from "./Images/connectNowbg.svg";
import counterbg from "./Images/counterbg.svg";
import countericon1 from "./Images/countericon1.svg";
import countericon2 from "./Images/countericon2.svg";
import countericon3 from "./Images/countericon3.svg";
import countericon4 from "./Images/countericon4.svg";
import galleryimage1 from "./Images/galleryimage1.svg";
import galleryimage2 from "./Images/galleryimage2.svg";
import galleryimage3 from "./Images/galleryimage3.svg";
import galleryimage4 from "./Images/galleryimage4.svg";
import galleryimage5 from "./Images/galleryimage5.svg";
import galleryimage6 from "./Images/galleryimage6.svg";
import galleryimage7 from "./Images/galleryimage7.svg";
import galleryimage8 from "./Images/galleryimage8.svg";
import galleryimage9 from "./Images/galleryimage9.svg";
import galleryimage10 from "./Images/galleryimage10.svg";
import galleryimage11 from "./Images/galleryimage11.svg";
import galleryimage12 from "./Images/galleryimage12.svg";
import mediaimage1 from "./Images/mediaimage1.svg";
import mediaimage2 from "./Images/mediaimage2.svg";
import mediaimage3 from "./Images/mediaimage3.svg";
import mediaimage4 from "./Images/mediaimage4.svg";
import TestimonialImg from "./Images/TestimonialImg.svg";


import Sticky from "../../stickySide/Sticky";
import { motion } from "framer-motion";
import Teams from "./Teams";
import Birthday from "./Birthday";
import Getintouch from "./Getintouch";
import Sliders from "./Banner SLider/Sliders";

import { blogs } from "../../Blogs copy/BlogData";
import BlogList from "../../Blogs copy/BlogList";
import Testomonail from "./Testomonial/Testomonail";
import axios from "axios";
import Modal from "react-modal";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import TopHerosection from "./TopHerosection";
import YT from "./YouTube/YT";

Modal.setAppElement("#root"); // Ensure modal accessibility

interface ImageData {
  image: string;
}


interface gallerydata{
  id:number,
  image:string,
}
const Homes = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[galleryimagedata, setGalleryImagedata] = useState<gallerydata[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Open modal and set selected image index
  const openModal = (index: number) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<gallerydata[]>(
          `${api}/auth/gallery`
        );

        //console.log('gallery data',response.data)
        setGalleryImagedata(response.data);
      } catch (error) {
        console.error("gallery Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="">
      <Header />
      {/* sticky component */}
      

      <Sticky />
      {/**
       * Slider
       */}
       {/* <Sliders/> */}
       <TopHerosection/>

      
      
      {/* letst news      */}
      <div className="bg-[#1E2A3A] py-14 px-[8%] ">
        <div className="flex flex-wrap w-[100%]">
          <div className=" sm:w-[50%]">
            <p className="text-[#F1F4F9] text-[16px] font-normal leading-5 mb-4">
              OUR NEWS / EVENTS
            </p>
            <span className="text-[#F1F4F9] text-[39px] leading-10	font-bold	">
              Our
            </span>
            <span className="text-[39px] leading-10	font-bold	text-[#FDBC12] ml-2">
              Latest Meetings
            </span>
          </div>
          <div className=" sm:w-[50%] flex justify-end items-center sm:mt-0 mt-4">
            <a className="bg-[#02256D] w-[150px]  py-3 rounded text-[#F1F4F9] text-[16px] font-normal text-center"
            
            href="/rotary-events"
            >
              View All
            </a>
          </div>
        </div>
        {/* News boxs */}
        
        <BlogList blogs={blogs} count={3} />
      </div>
       {/* birthday */}
      <Birthday />
       {/* Testimonial */}
      <div className="bg-[#1E2A3A] py-14 px-[8%]">
        <h2 className="text-[39px] leading-10	font-bold	text-[#F1F4F9] ml-2">
          International Leaders Message
        </h2>
        <div className="flex w-[100%] justify-between mt-[60px] lg:flex-row flex-col gap-6">
         <div className="w-full rounded-2xl">
            <Testomonail/>
         </div>
         
        </div>
      </div>
      {/* why join us */}
      <div
        className="bg-cover bg-center   relative px-[8%]  w-[100%] flex flex-wrap"
        style={{ backgroundImage: `url(${Whyjoinbg})` }}
      >
        <div className="absolute inset-0  bg-[#010102] bg-opacity-85 "></div>
        <div className="relative z-10 lg:w-[60%] w-[100%] xl:pt-[60px] pt-[20px]">
          <h2 className="text-[#FDBC12] text-[39px] font-bold ">Why</h2>
          <h2 className="text-[#F1F4F9] text-[39px] font-bold leading-10	">
            {" "}
            RMB JOIN MUST !{" "}
          </h2>
          <div className="mt-6">
            <p className="text-[20px] font-semibold	text-[#E1E8F0] mt-3">
              01 Trusted Network :
            </p>
            <p className="text-[#94A2B8] text-[16px]">
              {" "}
              RMB brings together a community of Rotarians with shared values of
              service, integrity, and ethics, creating a trustworthy business
              environment.
            </p>
            <p className="text-[20px] font-semibold	text-[#E1E8F0] mt-8">
              02 Professional Growth :
            </p>
            <p className="text-[#94A2B8] text-[16px]">
              {" "}
              We offer valuable networking opportunities, helping members grow
              their businesses through connections with other successful
              professionals.
            </p>
            <p className="text-[20px] font-semibold	text-[#E1E8F0] mt-8">
              03 Community Service :
            </p>
            <p className="text-[#94A2B8] text-[16px]">
              RMB members actively contribute to society while building business
              relationships, aligning professional success with impactful
              service.
            </p>
           <a href="/about"> <button className="bg-[#FDBC12] w-[150px] py-3 rounded text-[#101729] text-[16px] font-normal mt-10">
              Know More
            </button>
            </a>
          </div>
        </div>
        <div className="lg:w-[40%] w-[100%] relative pt-[60px] z-10 flex lg:justify-end justify-center">
          <img className="h-[100%]  " src={ManImage} alt="" />
        </div>
      </div>
      {/* Welcome RBM */}
      <div className="bg-[#1E2A3A] px-[8%] py-[80px]  border-y border-[#465468] p-[50px]">
        <h2 className="text-center text-[39px] text-[#F1F4F9] font-bold	">
          Welcome to <br />
          <span className="text-[#FDBC12]"> Rotary Means Business </span> (RMB)
           Jaipur
        </h2>
        <p className="text-[#CBD5E0] text-[20px] text-center">
          Rotary Means Business encourages Rotarians and Non Rotarians to support the success of
          their fellow Rotarians by <br /> doing business with them, and by
          referring others to them.
        </p>
        <img
          className="w-full sm:h-[500px] h-[300px]"
          src={welcomeimage}
          alt=""
        />
      </div>
      {/* teams */}
      <Teams />
      {/* connect now */}
      <div
        className="px-[8%] py-[80px] bg-cover bg-center  relative flex flex-wrap items-center justify-between"
        style={{ backgroundImage: `url(${connectNowbg})` }}
      >
        <div className="absolute inset-0  bg-[#02256D] bg-opacity-95 "></div>
        <div className=" relative z-10 text-[#F1F4F9] text-[39px] font-bold ">
          <h2 className="leading-10	">
            Become part of a global network dedicated to <br />{" "}
            <span className="text-[#FDBC12]">
              {" "}
              mutual success and service.{" "}
            </span>
          </h2>
        </div>
        <a href="/contact"> <button className="bg-[#FDBC12] w-[150px] py-3 rounded text-[#101729] text-[16px] font-normal   relative z-40 xl:mt-0 mt-5">
         Connect Now
        </button>
        </a>
      </div>

     
      {/* countericon */}
      <div
        className="px-[8%] py-[80px] bg-cover bg-center relative flex flex-wrap items-center justify-between w-[100%] gap-y-5 "
        style={{ backgroundImage: `url(${counterbg})` }}
      >
        <div className="absolute inset-0  bg-[#070a13] bg-opacity-90"></div>
        <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col lg:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
          <img className="w-[72px]" src={countericon1} alt="" />
          <h2 className="text-[#FFFFFF] text-[39px] font-bold">255+</h2>
          <p className="text-[#FFFFFF] text-[16px] text-center">
            Chapters World Wide
          </p>
        </div>
        <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col lg:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
          <img className="w-[72px]" src={countericon2} alt="" />
          <h2 className="text-[#FFFFFF] text-[39px] font-bold">120+</h2>
          <p className="text-[#FFFFFF] text-[16px] text-center">
            Chapters in India
          </p>
        </div>
        <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col lg:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
          <img className="w-[72px]" src={countericon3} alt="" />
          <h2 className="text-[#FFFFFF] text-[39px] font-bold">1</h2>
          <p className="text-[#FFFFFF] text-[16px] text-center">
            Business Meetings in a year
          </p>
        </div>
        <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col lg:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
          <img className="w-[72px]" src={countericon4} alt="" />
          <h2 className="text-[#FFFFFF] text-[39px] font-bold">2</h2>
          <p className="text-[#FFFFFF] text-[16px] text-center">
            Members per classification
          </p>
        </div>
      </div>
      {/* gallery */}
      <div className="bg-[#1E2A3A]   py-[50px] px-[8%] hidden">
        <p className="text-[#F1F4F9] text-[16px] text-center">Stories FROM</p>
        <div className=" relative z-10 text-[#FDBC12] text-[39px] font-bold text-center">
          <h2 className="leading-12	">Event and Meetings</h2>
        </div>
        
        <div className="flex flex-wrap sm:justify-start justify-center gap-4  mt-6">
          {galleryimagedata.slice(0, 12).map((image,index)=>(
            
          <img className="md:w-[23.6%]  sm:w-[48%]" src={`${api}/${image.image}`} alt=""  onClick={() => openModal(index)}/>
          ))}
        </div>
        <Modal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50"
        overlayClassName="fixed inset-0 bg-black bg-opacity-80"
      >
        <div className="relative w-[90%] md:w-[70%] lg:w-[50%] bg-white p-5 rounded-lg">
          <button
            className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl"
            onClick={() => setIsOpen(false)}
          >
            ✖
          </button>

          {/* Swiper for Image Slideshow */}
          <Swiper
            modules={[Navigation]}
            navigation
            initialSlide={currentIndex}
            className="w-full h-full"
          >
            {galleryimagedata.map((image, index) => (
              <SwiperSlide key={index}>
                <img className="w-full h-auto rounded-lg" src={`${api}/${image.image}`} alt="" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Modal>
        <div className="flex justify-center items-center "> <div className="w-[180px] my-5 h-[60px] flex justify-center items-center bg-darkblue text-white cursor-pointer" onClick={()=>{
          window.location.href = '/gallery';
        }}>Load More</div>
      </div>
      
      </div>
        
     

      {/* RMB News & Media */}
      <div className="px-[8%] py-[80px]  bg-[#1E2A3A] border-y border-[#465468] ">
        <h2 className=" text-[39px] text-[#F1F4F9] font-bold	">
          RMB News & Media
        </h2>
        <div className="flex flex-wrap items-center justify-between w-[100%] gap-y-5 mt-10">
          <div className="bg-[#101729] border border-[#465468] p-5 flex flex-col md:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
            <img className="w-[72px]" src={mediaimage1} alt="" />
            <h2 className="text-[#F1F4F9] text-[20px] font-semibold mt-3	">
              News Channel
            </h2>
            <button className="w-[100%] bg-[#1E2A3A]  py-3 mt-5  rounded-lg text-[#D7D3D2] text-[13px]  hover:bg-[#FDBC12] hover:text-[#101729] hover:border-[#FDBC12]">
              Click Here
            </button>
          </div>
          <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col md:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
            <img className="w-[72px]" src={mediaimage2} alt="" />
            <h2 className="text-[#F1F4F9] text-[20px] font-semibold mt-3	">
              Print Media
            </h2>
            <button className="w-[100%] bg-[#1E2A3A]  py-3 mt-5  rounded-lg text-[#D7D3D2] text-[13px]  hover:bg-[#FDBC12] hover:text-[#101729] hover:border-[#FDBC12]">
              Click Here
            </button>
          </div>
          <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col md:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
            <img className="w-[72px]" src={mediaimage3} alt="" />
            <h2 className="text-[#F1F4F9] text-[20px] font-semibold mt-3	">
              Radio Media
            </h2>
            <button className="w-[100%] bg-[#1E2A3A]  py-3 mt-5  rounded-lg text-[#D7D3D2] text-[13px]  hover:bg-[#FDBC12] hover:text-[#101729] hover:border-[#FDBC12]">
              Click Here
            </button>
          </div>
          <div className="bg-[#101729] border border-[#465468] p-5 relative z-10 flex flex-col md:w-[24%] sm:w-[48%] w-[100%] items-center rounded-xl h-[225px] justify-center">
            <img className="w-[72px]" src={mediaimage4} alt="" />
            <h2 className="text-[#F1F4F9] text-[20px] font-semibold mt-3	">
              Other News
            </h2>
            <button className="w-[100%] bg-[#1E2A3A]  py-3 mt-5  rounded-lg text-[#D7D3D2] text-[13px]  hover:bg-[#FDBC12] hover:text-[#101729] hover:border-[#FDBC12]">
              Click Here
            </button>
          </div>
        </div>
      </div>
      
     <YT/>
      {/* Get in touch */}
      <Getintouch />
      <Footer />
    </div>
  );
};

export default Homes;
